<template>
	<div class="row">
		<div class="col-sm-10">
			<div class="row">
				<div class="col-sm-7">
					<label class="admin-text" for="prod-search">Nombre del proyecto</label><br>
					<input id="prod-search" class="admin-input" type="text" placeholder="Agrega el nombre del proyecto" v-model="form.title">
				</div>
			</div>
			<div class="row">
				<div class="col-sm-4">
					<div class="padding-top-sm">
						<p class="admin-text pull-left">Imágenes de proyecto:</p>
						<span class="admin-text"><strong>430 x 430px</strong></span>
					</div>
				</div>
				<div class="col-sm-3">
					<label class="btn btn-black btn-lg btn-file pull-right">
					    Subir imágenes <input type="file" style="display: none;" multiple @change="appendImg">
					</label>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<div class="wrapper" v-for="image in render_images" id="{{ $index }}" v-drag-and-drop drop="handleDrop">
						<i class="fa fa-bars pull-left" aria-hidden="true"></i>
						<p class="admin-text admin-text-sm pull-left">{{ image.name }}</p>
						<p class="admin-text admin-text-sm pull-right" @click="handleRemove(image, $index)"><u> Eliminar</u></p>
					</div>
				</div>
				<div class="col-sm-4" v-if="!render_images.length">
					<p class="text-general">Selecciona imágenes del proyecto.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<div class="textarea-container">
						<label for="" class="admin-text">Descripción del proyecto</label><br>
						<textarea name="" id="" rows="10" v-model="form.proyect_description"></textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.col-sm-2{
		padding: 0;
		margin-right: 15px;
	}
	i{
		color: #d8d8d8;
		font-size: 20px;
		padding: 5px;
	}
	textarea{
		width: 100%;
	}
	.textarea-container{
		padding: 0 15px;
	}
</style>

<script>
var form = {
	title: '',
	images: [],
	proyect_description: ''
};

export default {
	// ------ DATA ------

	data() {
		return {
			form: form
		};
	},

	// ------ METHODS ------ 

	methods: {
		handleDrop(old_item, new_item) {
			let tmp = this.form.images[old_item.id];
			this.form.images.$set(old_item.id, this.form.images[new_item.id]);
			this.form.images.$set(new_item.id, tmp);
		},

		handleRemove(item, index) {
			this.form.images.splice(index, 1);
		},

		appendImg(e) {
			// Add the product images.
			for (let i = 0, f = e.target.files; i < f.length; i++) {
				this.form.images.push(f[i]);
			}
		}
	},

	// ------ RENDER ------

	computed: {
		render_images() {
			return this.form.images;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-projects-general.vue?34b1d212